import { baseUrl } from "../../../lib/routes/baseUrl";

export const getAuthRoute = () => [`${baseUrl}`, "oauth", "token"].join("/");

export const getEditUserInfoRoute = (userId) =>
  [`${baseUrl}`, "security-api", "users", `${userId}`].join("/");

export const getAssignPermissionsToRoleRoute = (roleId, permissionsArr) =>
  [
    `${baseUrl}`,
    "security-api",
    "roles",
    `${roleId}`,
    `permissions?include=${encodeURIComponent(permissionsArr)}`,
  ].join("/");

export const getUsersRoute = (page = 0, size = 16) =>
  [`${baseUrl}`, "security-api", `users?page=${page}&size=${size}`].join("/");

export const getUsersPageableSearchRoute = (query) =>
  [`${baseUrl}`, "security-api", "users", `pageable-search?${query}page=0&size=500`].join("/");

export const getCreateRoleRoute = () => [`${baseUrl}`, "security-api", "roles"].join("/");

export const getUpdateRoleRoute = (roleId) =>
  [`${baseUrl}`, "security-api", "roles", `${roleId}`].join("/");

export const getDeleteRoleRoute = (roleId) =>
  [`${baseUrl}`, "security-api", "roles", `${roleId}`].join("/");

export const getUserByIdRoute = (userId) =>
  [`${baseUrl}`, "security-api", "users", userId].join("/");

export const getAssignPermissionsToUserRoute = (userId, permissionsArr, excludeArray) =>
  [
    `${baseUrl}`,
    "security-api",
    "users",
    userId,
    `permissions?include=${encodeURIComponent(permissionsArr)}&exclude=${encodeURIComponent(
      excludeArray
    )}`,
  ].join("/");

export const getAssignRolesToUserRoute = (userId, rolesArr) =>
  [
    `${baseUrl}`,
    "security-api",
    "users",
    userId,
    `roles?include=${encodeURIComponent(rolesArr)}`,
  ].join("/");

export const getBlockPermissionsToUserRoute = (userId, permissionsArr, includeArray) =>
  [
    `${baseUrl}`,
    "security-api",
    "users",
    userId,
    `permissions?include=${encodeURIComponent(includeArray)}&exclude=${encodeURIComponent(
      permissionsArr
    )}`,
  ].join("/");

export const getPermissionsRoute = (page = 0, size = 1000) =>
  [`${baseUrl}`, "security-api", `permissions?page=${page}&size=${size}`].join("/");

export const getRolesRoute = (page = 0, size = 1000) =>
  [`${baseUrl}`, "security-api", `roles?page=${page}&size=${size}`].join("/");

export const createUserRoute = () => [`${baseUrl}`, "security-api", "users"].join("/");

export const getEditUserInfoStatusRoute = (userId) =>
  [`${baseUrl}`, "security-api", "users", userId, "status"].join("/");

export const getRequirementsRoute = () =>
  [`${baseUrl}`, "security-api", "passwords", "requirements"].join("/");

export const resetPasswordRoute = (userId) =>
  [`${baseUrl}`, "security-api", "users", userId, "password"].join("/");
